import script from "./import-recipe-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./import-recipe-modal.vue?vue&type=script&setup=true&lang=js"

import "./import-recipe-modal.vue?vue&type=style&index=0&id=30dd4568&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30dd4568"]])

export default __exports__